/**
 * The default number configuration.
 * Example: 22,000.00
 */
export const defaultNumberConfig = {
    decimalSeparator: '.',
    decimalPrecision: 2,
    thousandsSeparator: ',',
    nonNumberPlaceholder: ''
};
//# sourceMappingURL=number.js.map